/**
 * @flow
 * @relayHash fd7d6b7ff826e78e2cc0f297b8fcbf63
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PurchaseUpsLabelInput = {|
  shipmentId: string,
  serviceCode: string,
|};
export type PurchaseUpsLabelMutationVariables = {|
  input: PurchaseUpsLabelInput
|};
export type PurchaseUpsLabelMutationResponse = {|
  +purchaseUpsLabel: {|
    +error: ?string,
    +shipmentEdge: {|
      +node: {|
        +id: string,
        +trackingNumber: ?string,
        +carrierName: ?string,
        +shippingMethod: ?string,
        +shippingCost: ?number,
        +serviceType: ?string,
        +serviceName: ?string,
        +shippingLabelUrl: ?string,
        +upsShipmentId: ?string,
      |}
    |},
  |}
|};
export type PurchaseUpsLabelMutation = {|
  variables: PurchaseUpsLabelMutationVariables,
  response: PurchaseUpsLabelMutationResponse,
|};
*/


/*
mutation PurchaseUpsLabelMutation(
  $input: PurchaseUpsLabelInput!
) {
  purchaseUpsLabel(input: $input) {
    error
    shipmentEdge {
      node {
        id
        trackingNumber
        carrierName
        shippingMethod
        shippingCost
        serviceType
        serviceName
        shippingLabelUrl
        upsShipmentId
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PurchaseUpsLabelInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "purchaseUpsLabel",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PurchaseUpsLabelPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "shipmentEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "ShipmentEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Shipment",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "trackingNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "carrierName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingMethod",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingCost",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "serviceType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "serviceName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingLabelUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "upsShipmentId",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PurchaseUpsLabelMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "PurchaseUpsLabelMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "PurchaseUpsLabelMutation",
    "id": null,
    "text": "mutation PurchaseUpsLabelMutation(\n  $input: PurchaseUpsLabelInput!\n) {\n  purchaseUpsLabel(input: $input) {\n    error\n    shipmentEdge {\n      node {\n        id\n        trackingNumber\n        carrierName\n        shippingMethod\n        shippingCost\n        serviceType\n        serviceName\n        shippingLabelUrl\n        upsShipmentId\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '71632e5d40c8ed29bbbcd0b6ac9ed9ec';
module.exports = node;
